import {Component} from '@angular/core';

@Component({
    selector: 'app-view-user-registration',
    templateUrl: './view-user-registration.component.html',
    styleUrl: './view-user-registration.component.css'
})
export class ViewUserRegistrationComponent {

}
